module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/Robin-Hood.bb0a47b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/Robin-Hood.jpg
// module id = VY3d
// module chunks = 0